import { Tag, TagProps } from '@rahtab/ui';
import { LoadStatusCode } from 'hooks/useVetApproveHistory';
import React from 'react';

const statusTagProps: Record<LoadStatusCode, Omit<TagProps, 'text'>> = {
  //تایید شده
  [LoadStatusCode.Approved]: {
    backgroundColor: 'green',
    color: 'white',
  },
  //در انتظار تایید
  [LoadStatusCode.Pending]: {
    backgroundColor: 'primary',
    color: 'white',
  },
  //منقضی شده
  [LoadStatusCode.Expired]: {
    backgroundColor: 'default',
    color: 'secondary',
  },
  //گزارش شده
  [LoadStatusCode.Reported]: {
    backgroundColor: 'secondary',
    color: 'white',
  },
};

interface ItemStatusTagProps {
  code: LoadStatusCode;
  text: string;
}

const ItemStatusTag = (props: ItemStatusTagProps) => {
  const { code, text } = props;

  return <Tag text={text} backgroundColor={statusTagProps[code].backgroundColor} color={statusTagProps[code].color} />;
};
export default ItemStatusTag;
